import { useCallback } from 'react';

import { useTrackCanvasDraftAbandoned } from '@air/analytics';

import { useWorkspaceRightPanelStore } from '~/components/v2/store/features/workspace/useWorkspaceRightPanelStore';

/**
 * Shared hook that fires canvas_draft_abandoned analytics and clears draft state.
 * Used by useDraftCanvas, useSelectedCanvasId, and useSelectedCanvasIdSync to
 * avoid duplicating the abandonment pattern.
 */
export const useDiscardDraftCanvas = () => {
  const { trackCanvasDraftAbandoned } = useTrackCanvasDraftAbandoned();

  return useCallback(() => {
    const draft = useWorkspaceRightPanelStore.getState().draftCanvas;

    if (draft) {
      trackCanvasDraftAbandoned(draft.analyticsContext);
      useWorkspaceRightPanelStore.getState().setDraftCanvas(null);
    }
  }, [trackCanvasDraftAbandoned]);
};
